module.exports = __webpack_public_path__ + "img/banner-TV-1__xl--old.6f7c35f7.jpg";